import React from 'react';
import PropTypes from 'prop-types';
import { HrButtons, HrFlexContainer, HrParagraph, HrTitleH4 } from '@components/styles/hr-styles';
import { Modal } from '@/components/v1/Modal';
import { useTranslationWithPrefix } from '@/i18n/hooks';

/**
 * Aviso de que la plantilla de la solicitud cambió y el formulario quedó desactualizado (D6).
 *
 * Se le ofrece conservar lo cargado: al refrescar, esos datos se vuelven a volcar. Los campos que
 * ya no existan en la plantilla nueva se descartan en silencio — el diálogo ya avisó que cambió, y
 * es la decisión D11.
 */
export const TemplateChangedModal = ({ isOpen, onClose, onRefreshKeepingDraft, onRefreshDiscardingDraft }) => {
  const { t } = useTranslationWithPrefix('requestVacancies.templateChanged');

  return (
    <Modal isOpen={isOpen} toggleModal={onClose} topOffset={150}>
      <HrFlexContainer flexDirection='column' gap='16px' alignItems='flex-start'>
        <HrTitleH4>{t('title')}</HrTitleH4>
        <HrParagraph>{t('description')}</HrParagraph>
        <HrParagraph>{t('question')}</HrParagraph>

        <HrFlexContainer justifyContent='flex-end' flexWrap='nowrap' gap='16px' padding='16px 0 0 0'>
          <HrButtons type='button' category='cancel' size='medium' onClick={onRefreshDiscardingDraft}>
            {t('discard')}
          </HrButtons>
          <HrButtons type='button' category='primary' size='medium' onClick={onRefreshKeepingDraft}>
            {t('keep')}
          </HrButtons>
        </HrFlexContainer>
      </HrFlexContainer>
    </Modal>
  );
};

TemplateChangedModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRefreshKeepingDraft: PropTypes.func.isRequired,
  onRefreshDiscardingDraft: PropTypes.func.isRequired
};
